(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["founding-member"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('founding-member-signup')) {
    customElements.define(
      'founding-member-signup',
      class FoundingMemberSignup extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('.fm__dialog');
          if (!this.dialog || this.dialog.dataset.fmBound === 'true') return;
          this.dialog.dataset.fmBound = 'true';

          this.onOpen = this.open.bind(this);
          this.onClose = this.close.bind(this);

          this.querySelectorAll('[data-fm-open]').forEach((el) => el.addEventListener('click', this.onOpen));
          this.querySelectorAll('[data-fm-close]').forEach((el) => el.addEventListener('click', this.onClose));

          // Click on the backdrop (outside .fm__dialog-inner) closes.
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
          });

          this.dialog.addEventListener('close', () => {
            document.documentElement.classList.remove('fm-scroll-locked');
          });

          // Theme editor: reveal the dialog while its app block is selected.
          if (window.Shopify && window.Shopify.designMode) {
            document.addEventListener('shopify:block:select', (event) => {
              if (this.contains(event.target)) this.open();
            });
            document.addEventListener('shopify:block:deselect', (event) => {
              if (this.contains(event.target)) this.close();
            });
          }
        }

        open() {
          if (!this.dialog || this.dialog.open) return;
          this.dialog.classList.remove('fm__dialog--closing');
          this.dialog.showModal();
          document.documentElement.classList.add('fm-scroll-locked');
          this.dialog.focus();
        }

        close() {
          const dialog = this.dialog;
          if (!dialog || !dialog.open || dialog.classList.contains('fm__dialog--closing')) return;

          // Reduced motion, or no animation support: close immediately.
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            dialog.close();
            return;
          }

          // Let the exit animation play before the dialog leaves the top layer.
          dialog.classList.add('fm__dialog--closing');

          const finish = () => {
            window.clearTimeout(this.closeTimer);
            dialog.classList.remove('fm__dialog--closing');
            dialog.close();
          };

          dialog.addEventListener('animationend', finish, { once: true });
          // Safety net in case the animation never fires (hidden tab, etc).
          this.closeTimer = window.setTimeout(finish, 400);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
